module.exports = __webpack_public_path__ + "img/ufa-bet-support.bbb649ee.png";